export const companyAtividadesModel = [
	{ value: "1", label: "Bebidas" }, 
	{ value: "2", label: "Celulose, papel e produtos de papel" }, 
	{ value: "3", label: "Confecção de artigos do vestuário e acessórios" }, 
	{ value: "4", label: "Coque, produtos derivados do petróleo e biocombustíveis" }, 
	{ value: "5", label: "Couros, artigos para viagem e calçados" }, 
	{ value: "6", label: "Equipamentos de informática, produtos eletrônicos e ópticos" }, 
	{ value: "7", label: "Impressão e reprodução de gravações" }, 
	{ value: "8", label: "Indústria Geral" }, 
	{ value: "9", label: "Indústrias de Transformação" }, 
	{ value: "10", label: "Indústrias Extrativas" }, 
	{ value: "11", label: "Manutenção, reparação e instalação de máquinas e equipamentos" }, 
	{ value: "12", label: "Metalurgia" }, 
	{ value: "13", label: "Máquinas e equipamentos" }, 
	{ value: "14", label: "Máquinas, aparelhos e materiais elétricos" }, 
	{ value: "15", label: "Móveis" }, 
	{ value: "16", label: "Outra" }, 
	{ value: "17", label: "Outros equipamentos de transporte" }, 
	{ value: "18", label: "Outros produtos químicos" }, 
	{ value: "19", label: "Perfumaria, sabões, detergentes, produtos de limpeza e de higiene pessoal" }, 
	{ value: "20", label: "Produtos alimentícios" }, 
	{ value: "21", label: "Produtos de borracha e de material plástico" }, 
	{ value: "22", label: "Produtos de madeira" }, 
	{ value: "23", label: "Produtos de metal, exceto máquinas e equipamentos" }, 
	{ value: "24", label: "Produtos de minerais não-metálicos" }, 
	{ value: "25", label: "Produtos diversos" }, 
	{ value: "26", label: "Produtos do fumo" }, 
	{ value: "27", label: "Produtos farmoquímicos e farmacêuticos" }, 
	{ value: "28", label: "Produtos têxteis" }, 
	{ value: "29", label: "Veículos automotores, reboques e carrocerias" }, 
];


// WEBPACK FOOTER //
// src/models/lib/companyAtividadesModel.js